export const FULLSCREEN_BOUNDS = 'fullscreen';

type Rect = { x: number; y: number; width: number; height: number };

/**
 * Render a rectangle as the agent-facing "x y width height" string, collapsing a rectangle that
 * covers exactly the canvas to `fullscreen`. Full-bleed media and backgrounds are the most common
 * bounds in a video, and the word reads more plainly than four numbers the agent has to check
 * against the resolution — at a fraction of the tokens.
 */
export const formatBounds = (
    rect: Rect,
    canvas: { width: number; height: number },
    round: (value: number) => number = Math.round,
): string => {
    const x = round(rect.x);
    const y = round(rect.y);
    const width = round(rect.width);
    const height = round(rect.height);
    if (x === 0 && y === 0 && width === canvas.width && height === canvas.height) {
        return FULLSCREEN_BOUNDS;
    }
    return `${x} ${y} ${width} ${height}`;
};
